import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { useMedia } from 'pricing-pages-ui-components/hooks/useMedia';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { HUBSPOT_CREDITS_CARDS_SECTION } from '../../../constants/tracking/TrackingSources';
import { useAppSelector } from '../../../reducers';
import { isUngatedForInbound25Selector } from '../../../selectors/GatingSelectors';
import ProductAndServicesCatalogLink from '../../ProductAndServicesCatalogLink';
import MobileMerchCardSelectorButtons from '../../mobile/MobileMerchCardSelectorButtons';
import { SIZE_TO_LOCATION_MAP } from './constants';
import HubSpotCreditsTileInbound25 from './HubSpotCreditsTileInbound25';
import HubSpotCreditsColumnLayout from './HubSpotCreditsColumnLayout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HubSpotCreditsTilesContainerInbound25 = ({
  screen,
  unlockHubSpotCreditsSkuIds
}) => {
  const isMobile = useMedia('tabletPortrait');
  const [selectedSize, setSelectedSize] = useState('SMALL');
  const isUngatedForInbound25 = useAppSelector(isUngatedForInbound25Selector);
  if (isMobile) return /*#__PURE__*/_jsxs(PageSection, {
    children: [/*#__PURE__*/_jsx(MobileMerchCardSelectorButtons, {
      options: ['SMALL', 'MEDIUM', 'LARGE'],
      onClick: setSelectedSize,
      selectedOption: selectedSize
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "500",
      marginBlockEnd: "800",
      children: /*#__PURE__*/_jsx(HubSpotCreditsTileInbound25, {
        size: selectedSize,
        location: SIZE_TO_LOCATION_MAP[selectedSize],
        screen: screen,
        unlockHubSpotCreditsSkuIds: unlockHubSpotCreditsSkuIds,
        columnStart: 1,
        isCollapsible: true
      })
    }), /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(ProductAndServicesCatalogLink, {
        trackingSource: HUBSPOT_CREDITS_CARDS_SECTION,
        section: "#HubSpotCreditsRateSheet",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.hubspot-credits.links.viewCreditsRateSheet"
        })
      })
    })]
  });
  return /*#__PURE__*/_jsxs(HubSpotCreditsColumnLayout, {
    screen: screen,
    unlockHubSpotCreditsSkuIds: unlockHubSpotCreditsSkuIds,
    isUngatedForInbound25: isUngatedForInbound25,
    columns: 3,
    viewProps: {
      marginBlockEnd: '800',
      borderWidth: '100',
      borderStyle: 'solid',
      borderColor: 'border-core-subtle',
      borderRadius: '300',
      'aria-hidden': true
    },
    children: [/*#__PURE__*/_jsx(HubSpotCreditsTileInbound25, {
      size: "SMALL",
      location: "HUBSPOT_CREDITS_MERCH_CARD_SMALL",
      screen: screen,
      unlockHubSpotCreditsSkuIds: unlockHubSpotCreditsSkuIds,
      columnStart: 1
    }), /*#__PURE__*/_jsx(HubSpotCreditsTileInbound25, {
      size: "MEDIUM",
      location: "HUBSPOT_CREDITS_MERCH_CARD_MEDIUM_LARGE",
      screen: screen,
      unlockHubSpotCreditsSkuIds: unlockHubSpotCreditsSkuIds,
      columnStart: 2
    }), /*#__PURE__*/_jsx(HubSpotCreditsTileInbound25, {
      size: "LARGE",
      location: "HUBSPOT_CREDITS_MERCH_CARD_MEDIUM_LARGE",
      screen: screen,
      unlockHubSpotCreditsSkuIds: unlockHubSpotCreditsSkuIds,
      columnStart: 3
    })]
  });
};